import type { ReactNode } from 'react';

import { Badge } from '../../ui/badge';
import { cn } from '../../ui/utils';
import { Hint } from '../hint';

import { Absent } from './Absent';
import { mt } from './messages';

export function ProviderFidelity(props: {
  provider: string | null;
  fidelity: 'MEASURED' | 'ESTIMATED';
}): ReactNode {
  return (
    <span className="inline-flex items-center gap-1">
      {props.provider === null && <Absent reason="not_observable" />}
      <Badge
        variant={props.fidelity === 'MEASURED' ? 'secondary' : 'outline'}
        className={cn(props.fidelity === 'ESTIMATED' && 'border-dashed')}
      >
        {mt(`fidelity.${props.fidelity}`)}
      </Badge>
      <Hint label={mt('fidelity.about')}>{mt(`fidelity.explain.${props.fidelity}`)}</Hint>
    </span>
  );
}
